export const PENDING_VALIDATION_POST_URGENCY_THRESHOLD_HOURS = 72;
